// Explore's menu: the Solar System view alone. The Atlas's own imagery credit
// line carries the USGS/NASA credits, so there is no Credits tab.

import { renderAtlasPane } from './atlas';
import { EXPLORE_GROUND } from './atlas/groundGame.explore';
import type { MenuTab } from './menu';

export const EXPLORE_TABS: readonly MenuTab[] = [
  { id: 'solar', icon: '☉', label: 'Solar System', section: 'bridge', render: (host) => renderAtlasPane(host, EXPLORE_GROUND) },
];
